module.exports = __webpack_public_path__ + "img/tablet-hamburgueria.cce47c68.webp";